import 'x.core';
import 'x.izi';
import 'app.vue.vuex';


export const core = {

    init () {
        // собственный лезилойдинг после vue
        BX.addCustomEvent('x.vue.loader:inited',(a,b) => {
            document.querySelectorAll('img[data-src]').forEach((i)=>{
                    i.setAttribute('src',i.dataset.src);
                    i.removeAttribute('data-src');
                });
            document.querySelectorAll('iframe[data-src]').forEach((i)=>{
                    i.setAttribute('src',i.dataset.src);
                    i.removeAttribute('data-src');
                });
            // document.querySelectorAll('source[data-srcset]').forEach((i)=>{
            //         i.setAttribute('srcset',i.dataset.src);
            //         i.removeAttribute('data-srcset');
            //     });
            document.querySelectorAll('[data-style]').forEach((i)=>{
                    i.setAttribute('style',i.dataset.style);
                    i.removeAttribute('data-style');
                });
        });
        
    },
    // initSliders () {
    //     let sliders = document.querySelectorAll('[app-slider]');
    //     sliders.forEach((sliderNode)=>{
    //             new Slider(sliderNode);
    //         });
    // }
}

console.time('app.core.load');
window.addEventListener('load', ()=>{
    BX.ready(() => {
            BX.onCustomEvent('app.core:loaded');
            console.timeEnd('app.core.load');

            core.init();

            BX.onCustomEvent('app.core:inited');
        });
});